// These are deprecated ids that we maintain for backwards compatibility
import { TranslateMapConfig } from '@urc-ui/hooks/translate-map';
import { logger } from '@urc-ui/services/logger';
import { REPORT_CATEGORY } from '@urc-ui/utils/types';

// Keys for translation map
export enum REPORT_TYPE_TEXT {
  ADVERTISED_PRODUCT = 'ADVERTISED_PRODUCT_REPORT_TEXT',
  ATTRIBUTED_PURCHASES = 'ATTRIBUTED_PURCHASES_REPORT_TEXT',
  ALL_AUDIENCES = 'ALL_AUDIENCES_REPORT_TEXT',
  BRAND_CATEGORY_BENCHMARK = 'BRAND_CATEGORY_BENCHMARK_REPORT_TEXT',
  BRAND_HALO_PRODUCTS = 'BRAND_HALO_PRODUCTS_REPORT_TEXT',
  BRAND_HALO_PRODUCTS_ROLLUP = 'BRAND_HALO_PRODUCTS_ROLLUP_REPORT_TEXT',
  BRAND_HALO_SNAPSHOT = 'BRAND_HALO_SNAPSHOT_REPORT_TEXT',
  BUDGET = 'BUDGET_REPORT_TEXT',
  CAMPAIGN_PERFORMANCE = 'CAMPAIGN_PERFORMANCE_REPORT_TEXT',
  CAMPAIGN_PLACEMENTS = 'CAMPAIGN_PLACEMENTS_REPORT_TEXT',
  CAMPAIGN = 'CAMPAIGN_REPORT_TEXT',
  CHANNEL_PUBLISHER_PERFORMANCE = 'CHANNEL_PUBLISHER_PERFORMANCE_REPORT_TEXT',
  FIRETV_CAMPAIGN = 'FIRETV_CAMPAIGN_REPORT_TEXT',
  GROSS_AND_INVALID_TRAFFIC = 'GROSS_AND_INVALID_TRAFFIC_REPORT_TEXT',
  KEYWORD_PLACEMENTS = 'KEYWORD_PLACEMENTS_REPORT_TEXT',
  KEYWORD = 'KEYWORD_REPORT_TEXT',
  KEYWORDS_CREATIVE = 'KEYWORDS_CREATIVE_REPORT_TEXT',
  LANDING_PAGE_PERFORMANCE = 'LANDING_PAGE_PERFORMANCE_REPORT_TEXT',
  MATCHED_TARGETING = 'MATCHED_TARGETING_REPORT_TEXT',
  PERFORMANCE_OVER_TIME = 'PERFORMANCE_OVER_TIME_REPORT_TEXT',
  PLACEMENT = 'PLACEMENT_REPORT_TEXT',
  PURCHASED_PRODUCT = 'PURCHASED_PRODUCT_REPORT_TEXT',
  PROMOTED_PRODUCTS = 'PROMOTED_PRODUCTS_REPORT_TEXT',
  PROMOTED_PRODUCTS_ROLLUP = 'PROMOTED_PRODUCTS_ROLLUP_REPORT_TEXT',
  SEARCH_TERM_IMPRESSION_RANK = 'SEARCH_TERM_IMPRESSION_RANK_REPORT_TEXT',
  SEARCH_TERM = 'SEARCH_TERM_REPORT_TEXT',
  TARGETING = 'TARGETING_REPORT_TEXT',
  TOP_AUDIENCE_CONSIDERATION = 'TOP_AUDIENCE_CONSIDERATION_REPORT_TEXT',
  TOP_AUDIENCE_PURCHASES = 'TOP_AUDIENCE_PURCHASES_REPORT_TEXT',
  INDUSTRY_STANDARD = 'INDUSTRY_STANDARD_REPORT_TEXT',
  INDUSTRY_STANDARD_V2 = 'INDUSTRY_STANDARD_V2_REPORT_TEXT',
  INVENTORY = 'INVENTORY_REPORT_TEXT',
  SITE_AND_SUPPLY = 'SITE_AND_SUPPLY_REPORT_TEXT',
  AUDIENCE = 'AUDIENCE_REPORT_TEXT',
  PRODUCTS = 'PRODUCTS_REPORT_TEXT',
  TECHNOLOGY = 'TECHNOLOGY_REPORT_TEXT',
  GEOGRAPHY = 'GEOGRAPHY_REPORT_TEXT',
  GEOGRAPHY_WITHOUT_DMA = 'GEOGRAPHY_WITHOUT_DMA_REPORT_TEXT',
  CONTEXTUAL = 'CONTEXTUAL_REPORT_TEXT',
  THIRD_PARTY_FEES = 'THIRD_PARTY_FEES_REPORT_TEXT',
  CONVERSION_SOURCE = 'CONVERSION_SOURCE_REPORT_TEXT',
  OFF_AMAZON_CONVERSION = 'OFF_AMAZON_CONVERSION_REPORT_TEXT',
  PRICING_TRANSPARENCY = 'PRICING_TRANSPARENCY_TEXT',
  CONVERSION_PATH = 'CONVERSION_PATH_TEXT',
  BENCHMARKS = 'BENCHMARKS_TEXT',
  PROMPTS = 'PROMPT_REPORT_TEXT',
  VIDEO = 'VIDEO_REPORT_TEXT'
}

// RMS report types
export enum RMS_REPORT_TYPE {
  ADS_REPORT = 'adProducts',
  ALL_AUDIENCES_REPORT = 'allAudiences',
  ATTRIBUTED_PURCHASES_REPORT = 'attributedPurchases',
  BRAND_HALO_PRODUCTS_REPORT = 'brandHaloProducts',
  BRAND_HALO_PRODUCTS_ROLLUP_REPORT = 'brandHaloProductsRollup',
  BRAND_HALO_SNAPSHOT_REPORT = 'brandHalo',
  BUDGETS_REPORT = 'budgets',
  CAMPAIGN_PERFORMANCE_REPORT = 'campaignPerformance',
  CAMPAIGN_PLACEMENTS_REPORT = 'campaignPlacements',
  CAMPAIGNS_REPORT = 'campaigns',
  CHANNEL_PUBLISHER_PERFORMANCE_REPORT = 'channelPublisherPerformance',
  FIRETV_CAMPAIGNS_REPORT = 'fireTvCampaigns',
  GROSS_AND_INVALID_TRAFFIC_REPORT = 'grossAndInvalidTraffic',
  KEYWORD_PLACEMENTS_REPORT = 'keywordPlacements',
  KEYWORDS_CREATIVE_REPORT = 'keywordsCreative',
  KEYWORDS_REPORT = 'keywords',
  KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST = 'keywordsOfflineReportingApi',
  LANDING_PAGE_PERFORMANCE_REPORT = 'landingPagePerformance',
  MATCHED_TARGET_REPORT = 'matchedTarget',
  PEER_BENCHMARK_REPORT = 'peerBenchmark',
  PERFORMANCE_OVER_TIME_REPORT = 'performanceOverTime',
  PLACEMENTS_REPORT = 'placements',
  PROMOTED_PRODUCTS_REPORT = 'promotedProducts',
  PROMOTED_PRODUCTS_ROLLUP_REPORT = 'promotedProductsRollup',
  PURCHASED_PRODUCTS_REPORT = 'purchasedProducts',
  SEARCH_TERMS_REPORT = 'searchTerms',
  SEARCH_TERMS_IMPRESSION_RANK_REPORT = 'searchTermsImpressionRank',
  TOP_AUDIENCE_CONSIDERATION_REPORT = 'audienceConsideration',
  TOP_AUDIENCE_PURCHASES_REPORT = 'topAudiencePurchases',
  PRICING_TRANSPARENCY = 'pricingTransparency',
  CONVERSION_PATH = 'conversionPath',
  BENCHMARKS = 'crossProgramBenchmarks',
  AUDIENCE_REPORT = 'audience',
  PROMPTS = 'prompts',
  VIDEO = 'videos'
}

export enum ADSP_REPORT_TYPE {
  CAMPAIGN = 'CAMPAIGN',
  INDUSTRY_STANDARD = 'INDUSTRY_STANDARD',
  INDUSTRY_STANDARD_V2 = 'INDUSTRY_STANDARD_V2',
  INVENTORY = 'INVENTORY',
  SITE_AND_SUPPLY = 'SITE_AND_SUPPLY',
  AUDIENCE = 'AUDIENCE',
  PRODUCTS = 'PRODUCTS',
  TECHNOLOGY = 'TECHNOLOGY',
  GEOGRAPHY = 'GEOGRAPHY',
  GEOGRAPHY_WITHOUT_DMA = 'GEOGRAPHY_WITHOUT_DMA',
  CONTEXTUAL = 'CONTEXTUAL',
  THIRD_PARTY_FEES = 'THIRD_PARTY_FEES',
  CONVERSION_SOURCE = 'CONVERSION_SOURCE',
  OFF_AMAZON_CONVERSION = 'OFF_AMAZON_CONVERSION'
}

// Constants for report types
export enum REPORT_TYPE {
  ADS = 'ADS_REPORT',
  ALL_AUDIENCES = 'ALL_AUDIENCES_REPORT',
  ATTRIBUTED_PURCHASES = 'ATTRIBUTED_PURCHASES_REPORT',
  BRAND_HALO_PRODUCTS = 'BRAND_HALO_PRODUCTS_REPORT',
  BRAND_HALO_PRODUCTS_ROLLUP = 'BRAND_HALO_PRODUCTS_ROLLUP_REPORT',
  BRAND_HALO_SNAPSHOT = 'BRAND_HALO_SNAPSHOT_REPORT',
  BUDGETS = 'BUDGETS_REPORT',
  CAMPAIGN_PERFORMANCE = 'CAMPAIGN_PERFORMANCE_REPORT',
  CAMPAIGN_PLACEMENTS = 'CAMPAIGN_PLACEMENTS_REPORT',
  CAMPAIGNS = 'CAMPAIGNS_REPORT',
  CAMPAIGNS_V2 = 'CAMPAIGNS_REPORT_V2',
  CHANNEL_PUBLISHER_PERFORMANCE = 'CHANNEL_PUBLISHER_PERFORMANCE_REPORT',
  FIRETV_CAMPAIGNS = 'FIRETV_CAMPAIGNS_REPORT',
  GROSS_AND_INVALID_TRAFFIC = 'GROSS_AND_INVALID_TRAFFIC_REPORT',
  KEYWORDS_CREATIVE = 'KEYWORDS_CREATIVE_REPORT',
  KEYWORDS = 'KEYWORDS_REPORT',
  KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST = 'KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST',
  KEYWORD_PLACEMENTS = 'KEYWORD_PLACEMENTS_REPORT',
  LANDING_PAGE_PERFORMANCE = 'LANDING_PAGE_PERFORMANCE_REPORT',
  LEGACY_CAMPAIGNS = 'LEGACY_CAMPAIGNS_REPORT',
  MATCHED_TARGETING = 'MATCHED_TARGETING_REPORT',
  PEER_BENCHMARK = 'PEER_BENCHMARK_REPORT',
  PERFORMANCE_OVER_TIME = 'PERFORMANCE_OVER_TIME_REPORT',
  PLACEMENTS_V2 = 'PLACEMENTS_REPORT_V2',
  PROMOTED_PRODUCTS = 'PROMOTED_PRODUCTS_REPORT',
  PROMOTED_PRODUCTS_ROLLUP = 'PROMOTED_PRODUCTS_ROLLUP_REPORT',
  PURCHASED_PRODUCTS = 'PURCHASED_PRODUCTS_REPORT',
  SEARCH_TERMS_IMPRESSION_RANK = 'SEARCH_TERMS_IMPRESSION_RANK_REPORT',
  SEARCH_TERMS = 'SEARCH_TERMS_REPORT',
  TOP_AUDIENCE_CONSIDERATION = 'TOP_AUDIENCE_CONSIDERATION_REPORT',
  TOP_AUDIENCE_PURCHASES = 'TOP_AUDIENCE_PURCHASES_REPORT',
  UNIFIED_CAMPAIGNS = 'UNIFIED_CAMPAIGNS_REPORT',
  UNIFIED_CAMPAIGN_PLACEMENTS = 'UNIFIED_CAMPAIGN_PLACEMENTS_REPORT',
  UNIFIED_KEYWORDS = 'UNIFIED_KEYWORDS_REPORT',
  UNIFIED_SEARCH_TERMS = 'UNIFIED_SEARCH_TERMS_REPORT',
  UNIFIED_ATTRIBUTED_PURCHASES = 'UNIFIED_ATTRIBUTED_PURCHASES_REPORT',
  AUDIENCE = 'AUDIENCE_REPORT',
  PROMPTS = 'PROMPTS_REPORT',
  VIDEO = 'VIDEO_REPORT'
}

const KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST_DEFAULT_STRING = 'Keywords Offline Reporting Api Launch Test';

export const REPORT_TYPE_TRANSLATION_MAP: TranslateMapConfig = {
  [REPORT_TYPE_TEXT.ADVERTISED_PRODUCT]: {
    id: 'sspa_rcm_ad_reports_report_types_advertised_product',
    default: 'Advertised product'
  },
  [REPORT_TYPE_TEXT.ALL_AUDIENCES]: { id: 'sspa_rcm_ad_reports_report_types_audiences', default: 'All audiences' },
  [REPORT_TYPE_TEXT.ATTRIBUTED_PURCHASES]: {
    id: 'sspa_rcm_ad_reports_report_types_attributed_purchases',
    default: 'Attributed Purchases'
  },
  [REPORT_TYPE_TEXT.BRAND_CATEGORY_BENCHMARK]: {
    id: 'sspa_rcm_ad_reports_report_types_brand_category_benchmark_report',
    default: 'Category benchmark'
  },
  [REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS]: { id: 'sspa_rcm_ad_reports_report_types_brand_halo_product', default: 'Brand halo product' },
  [REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS_ROLLUP]: {
    id: 'sspa_rcm_ad_reports_report_types_brand_halo_product_rollup',
    default: 'Brand halo product (Rollup)'
  },
  [REPORT_TYPE_TEXT.BRAND_HALO_SNAPSHOT]: {
    id: 'sspa_rcm_ad_reports_report_types_brand_halo_product_snapshot',
    default: 'Brand halo snapshot'
  },
  [REPORT_TYPE_TEXT.BUDGET]: { id: 'sspa_rcm_ad_reports_report_types_budget', default: 'Budget' },
  [REPORT_TYPE_TEXT.CAMPAIGN]: { id: 'sspa_rcm_ad_reports_report_types_campaign', default: 'Campaign' },
  [REPORT_TYPE_TEXT.CAMPAIGN_PLACEMENTS]: {
    id: 'sspa_rcm_ad_reports_report_types_campaign_placement',
    default: 'Campaign Placement'
  },
  [REPORT_TYPE_TEXT.CAMPAIGN_PERFORMANCE]: { id: 'sspa_rcm_ad_reports_report_types_attribution_campaign', default: 'Campaign' },
  [REPORT_TYPE_TEXT.CHANNEL_PUBLISHER_PERFORMANCE]: {
    id: 'sspa_rcm_ad_reports_report_types_channel_publisher',
    default: 'Channel publisher'
  },
  [REPORT_TYPE_TEXT.FIRETV_CAMPAIGN]: {
    id: 'sspa_rcm_ad_reports_report_types_entertainment_spotlight_ads_campaign',
    default: 'Entertainment Spotlight Ads Campaign'
  },
  [REPORT_TYPE_TEXT.GROSS_AND_INVALID_TRAFFIC]: {
    id: 'sspa_rcm_ad_reports_report_types_gross_and_invalid_traffic',
    default: 'Gross and Traffic'
  },
  [REPORT_TYPE_TEXT.KEYWORD]: { id: 'sspa_rcm_ad_reports_report_types_keywords', default: 'Keyword' },
  [REPORT_TYPE_TEXT.KEYWORD_PLACEMENTS]: {
    id: 'sspa_rcm_ad_reports_report_types_targeting_placements',
    default: 'Keyword Placement'
  },
  [REPORT_TYPE_TEXT.KEYWORDS_CREATIVE]: { id: 'sspa_rcm_ad_reports_report_types_keywords_creatives', default: 'Keywords or creative' },
  [REPORT_TYPE_TEXT.LANDING_PAGE_PERFORMANCE]: {
    id: 'sspa_rcm_ad_reports_report_types_landing_page',
    default: 'Landing page performance'
  },
  [REPORT_TYPE_TEXT.MATCHED_TARGETING]: { id: 'sspa_rcm_ad_reports_report_types_matched_target', default: 'Matched target' },
  [REPORT_TYPE_TEXT.PERFORMANCE_OVER_TIME]: {
    id: 'sspa_rcm_ad_reports_report_types_performance_over_time',
    default: 'Performance Over Time'
  },
  [REPORT_TYPE_TEXT.PLACEMENT]: { id: 'sspa_rcm_ad_reports_report_types_placement', default: 'Placement' },
  [REPORT_TYPE_TEXT.PROMOTED_PRODUCTS]: { id: 'sspa_rcm_ad_reports_report_types_promoted_product', default: 'Promoted product' },
  [REPORT_TYPE_TEXT.PROMOTED_PRODUCTS_ROLLUP]: {
    id: 'sspa_rcm_ad_reports_report_types_promoted_product_rollup',
    default: 'Promoted product (Rollup)'
  },
  [REPORT_TYPE_TEXT.PURCHASED_PRODUCT]: { id: 'sspa_rcm_ad_reports_report_types_purchased_product', default: 'Purchased product' },
  [REPORT_TYPE_TEXT.SEARCH_TERM]: { id: 'sspa_rcm_ad_reports_report_types_search_term', default: 'Search term' },
  [REPORT_TYPE_TEXT.SEARCH_TERM_IMPRESSION_RANK]: {
    id: 'sspa_rcm_ad_reports_report_types_search_term_impression_rank',
    default: 'Search term impression rank'
  },
  [REPORT_TYPE_TEXT.TARGETING]: { id: 'sspa_rcm_ad_reports_report_types_targeting', default: 'Targeting' },
  [REPORT_TYPE_TEXT.TOP_AUDIENCE_CONSIDERATION]: {
    id: 'sspa_rcm_ad_reports_report_types_audiences_consideration',
    default: 'Top 10 audiences—consideration'
  },
  [REPORT_TYPE_TEXT.TOP_AUDIENCE_PURCHASES]: {
    id: 'sspa_rcm_ad_reports_report_types_audiences_purchases',
    default: 'Top 10 audiences—purchases'
  },
  [REPORT_TYPE_TEXT.INDUSTRY_STANDARD]: {
    id: 'sspa_rcm_ad_reports_report_types_industry_standard',
    default: 'Industry standard'
  },
  [REPORT_TYPE_TEXT.INDUSTRY_STANDARD_V2]: {
    id: 'sspa_rcm_ad_reports_report_types_industry_standard_v2',
    default: ' Industry standard'
  },
  [REPORT_TYPE_TEXT.INVENTORY]: {
    id: 'sspa_rcm_ad_reports_report_types_inventory',
    default: 'Inventory'
  },
  [REPORT_TYPE_TEXT.SITE_AND_SUPPLY]: {
    id: 'sspa_rcm_ad_reports_report_types_site_and_supply',
    default: 'Site and supply'
  },
  [REPORT_TYPE_TEXT.AUDIENCE]: {
    id: 'sspa_rcm_ad_reports_report_types_audience',
    default: 'Audience'
  },
  [REPORT_TYPE_TEXT.PRODUCTS]: {
    id: 'sspa_rcm_ad_reports_report_types_products',
    default: 'Products'
  },
  [REPORT_TYPE_TEXT.TECHNOLOGY]: {
    id: 'sspa_rcm_ad_reports_report_types_technology',
    default: 'Technology'
  },
  [REPORT_TYPE_TEXT.GEOGRAPHY]: {
    id: 'sspa_rcm_ad_reports_report_types_geography',
    default: 'Geography'
  },
  [REPORT_TYPE_TEXT.GEOGRAPHY_WITHOUT_DMA]: {
    id: 'sspa_rcm_ad_reports_report_types_geography_without_dma',
    default: ' Geography'
  },
  [REPORT_TYPE_TEXT.CONTEXTUAL]: {
    id: 'sspa_rcm_ad_reports_report_types_contextual',
    default: 'Contextual'
  },
  [REPORT_TYPE_TEXT.THIRD_PARTY_FEES]: {
    id: 'sspa_rcm_ad_reports_report_types_third_party_fees',
    default: 'Third-party fees'
  },
  [REPORT_TYPE_TEXT.CONVERSION_SOURCE]: {
    id: 'sspa_rcm_ad_reports_report_types_coversion_source',
    default: 'Conversion source'
  },
  [REPORT_TYPE_TEXT.OFF_AMAZON_CONVERSION]: {
    id: 'sspa_rcm_ad_reports_report_types_off_amazon_coversion',
    default: 'Off Amazon Conversion'
  },
  [REPORT_TYPE_TEXT.PRICING_TRANSPARENCY]: {
    id: 'sspa_rcm_ad_reports_report_types_pricing_transparency',
    default: 'Pricing transparency'
  },
  [REPORT_TYPE_TEXT.CONVERSION_PATH]: {
    id: 'sspa_rcm_ad_reports_report_types_conversion_path',
    default: 'Conversion path'
  },
  [REPORT_TYPE_TEXT.BENCHMARKS]: {
    id: 'sspa_rcm_ad_reports_report_types_benchmark',
    default: 'Benchmarks'
  },
  [REPORT_TYPE_TEXT.PROMPTS]: {
    id: 'sspa_rcm_ad_reports_report_types_prompts',
    default: 'Prompts'
  },
  [REPORT_TYPE_TEXT.VIDEO]: {
    id: 'sspa_rcm_ad_reports_report_types_videos',
    default: 'Video'
  }
};

// Translation keys for general reports
export const GENERAL_REPORT_TYPE_MAP = {
  [REPORT_TYPE.ADS]: REPORT_TYPE_TEXT.ADVERTISED_PRODUCT,
  [REPORT_TYPE.ALL_AUDIENCES]: REPORT_TYPE_TEXT.ALL_AUDIENCES,
  [REPORT_TYPE.ATTRIBUTED_PURCHASES]: REPORT_TYPE_TEXT.ATTRIBUTED_PURCHASES,
  [REPORT_TYPE.BRAND_HALO_PRODUCTS]: REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS,
  [REPORT_TYPE.BRAND_HALO_PRODUCTS_ROLLUP]: REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS_ROLLUP,
  [REPORT_TYPE.BRAND_HALO_SNAPSHOT]: REPORT_TYPE_TEXT.BRAND_HALO_SNAPSHOT,
  [REPORT_TYPE.BUDGETS]: REPORT_TYPE_TEXT.BUDGET,
  [REPORT_TYPE.CAMPAIGN_PERFORMANCE]: REPORT_TYPE_TEXT.CAMPAIGN_PERFORMANCE,
  [REPORT_TYPE.CAMPAIGN_PLACEMENTS]: REPORT_TYPE_TEXT.CAMPAIGN_PLACEMENTS,
  [REPORT_TYPE.CAMPAIGNS]: REPORT_TYPE_TEXT.CAMPAIGN,
  [REPORT_TYPE.CAMPAIGNS_V2]: REPORT_TYPE_TEXT.CAMPAIGN,
  [REPORT_TYPE.CHANNEL_PUBLISHER_PERFORMANCE]: REPORT_TYPE_TEXT.CHANNEL_PUBLISHER_PERFORMANCE,
  [REPORT_TYPE.FIRETV_CAMPAIGNS]: REPORT_TYPE_TEXT.FIRETV_CAMPAIGN,
  [REPORT_TYPE.GROSS_AND_INVALID_TRAFFIC]: REPORT_TYPE_TEXT.GROSS_AND_INVALID_TRAFFIC,
  [REPORT_TYPE.KEYWORDS_CREATIVE]: REPORT_TYPE_TEXT.KEYWORDS_CREATIVE,
  [REPORT_TYPE.KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST]: KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST_DEFAULT_STRING,
  [REPORT_TYPE.KEYWORD_PLACEMENTS]: REPORT_TYPE_TEXT.KEYWORD_PLACEMENTS,
  [REPORT_TYPE.KEYWORDS]: REPORT_TYPE_TEXT.KEYWORD,
  [REPORT_TYPE.LEGACY_CAMPAIGNS]: REPORT_TYPE_TEXT.CAMPAIGN,
  [REPORT_TYPE.LANDING_PAGE_PERFORMANCE]: REPORT_TYPE_TEXT.LANDING_PAGE_PERFORMANCE,
  [REPORT_TYPE.MATCHED_TARGETING]: REPORT_TYPE_TEXT.MATCHED_TARGETING,
  [REPORT_TYPE.PEER_BENCHMARK]: REPORT_TYPE_TEXT.BRAND_CATEGORY_BENCHMARK,
  [REPORT_TYPE.PLACEMENTS_V2]: REPORT_TYPE_TEXT.PLACEMENT,
  [REPORT_TYPE.PROMOTED_PRODUCTS]: REPORT_TYPE_TEXT.PROMOTED_PRODUCTS,
  [REPORT_TYPE.PROMOTED_PRODUCTS_ROLLUP]: REPORT_TYPE_TEXT.PROMOTED_PRODUCTS_ROLLUP,
  [REPORT_TYPE.PURCHASED_PRODUCTS]: REPORT_TYPE_TEXT.PURCHASED_PRODUCT,
  [REPORT_TYPE.PERFORMANCE_OVER_TIME]: REPORT_TYPE_TEXT.PERFORMANCE_OVER_TIME,
  [REPORT_TYPE.SEARCH_TERMS_IMPRESSION_RANK]: REPORT_TYPE_TEXT.SEARCH_TERM_IMPRESSION_RANK,
  [REPORT_TYPE.SEARCH_TERMS]: REPORT_TYPE_TEXT.SEARCH_TERM,
  [REPORT_TYPE.TOP_AUDIENCE_CONSIDERATION]: REPORT_TYPE_TEXT.TOP_AUDIENCE_CONSIDERATION,
  [REPORT_TYPE.TOP_AUDIENCE_PURCHASES]: REPORT_TYPE_TEXT.TOP_AUDIENCE_PURCHASES,
  [REPORT_TYPE.UNIFIED_ATTRIBUTED_PURCHASES]: REPORT_TYPE_TEXT.ATTRIBUTED_PURCHASES,
  [REPORT_TYPE.UNIFIED_CAMPAIGN_PLACEMENTS]: REPORT_TYPE_TEXT.CAMPAIGN_PLACEMENTS,
  [REPORT_TYPE.UNIFIED_CAMPAIGNS]: REPORT_TYPE_TEXT.CAMPAIGN,
  [REPORT_TYPE.UNIFIED_KEYWORDS]: REPORT_TYPE_TEXT.KEYWORD,
  [REPORT_TYPE.UNIFIED_SEARCH_TERMS]: REPORT_TYPE_TEXT.SEARCH_TERM,
  [REPORT_TYPE.AUDIENCE]: REPORT_TYPE_TEXT.AUDIENCE,
  [REPORT_TYPE.PROMPTS]: REPORT_TYPE_TEXT.PROMPTS,
  [REPORT_TYPE.VIDEO]: REPORT_TYPE_TEXT.VIDEO
};

// Translation keys for rms reports
export const RMS_REPORT_TYPE_MAP = {
  [RMS_REPORT_TYPE.CAMPAIGNS_REPORT]: REPORT_TYPE_TEXT.CAMPAIGN,
  [RMS_REPORT_TYPE.FIRETV_CAMPAIGNS_REPORT]: REPORT_TYPE_TEXT.FIRETV_CAMPAIGN,
  [RMS_REPORT_TYPE.KEYWORDS_REPORT]: REPORT_TYPE_TEXT.TARGETING,
  [RMS_REPORT_TYPE.KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST]: KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST_DEFAULT_STRING,
  [RMS_REPORT_TYPE.ADS_REPORT]: REPORT_TYPE_TEXT.ADVERTISED_PRODUCT,
  [RMS_REPORT_TYPE.PURCHASED_PRODUCTS_REPORT]: REPORT_TYPE_TEXT.PURCHASED_PRODUCT,
  [RMS_REPORT_TYPE.SEARCH_TERMS_REPORT]: REPORT_TYPE_TEXT.SEARCH_TERM,
  [RMS_REPORT_TYPE.BUDGETS_REPORT]: REPORT_TYPE_TEXT.BUDGET,
  [RMS_REPORT_TYPE.PLACEMENTS_REPORT]: REPORT_TYPE_TEXT.PLACEMENT,
  [RMS_REPORT_TYPE.PERFORMANCE_OVER_TIME_REPORT]: REPORT_TYPE_TEXT.PERFORMANCE_OVER_TIME,
  [RMS_REPORT_TYPE.KEYWORD_PLACEMENTS_REPORT]: REPORT_TYPE_TEXT.KEYWORD_PLACEMENTS,
  [RMS_REPORT_TYPE.SEARCH_TERMS_IMPRESSION_RANK_REPORT]: REPORT_TYPE_TEXT.SEARCH_TERM_IMPRESSION_RANK,
  [RMS_REPORT_TYPE.PEER_BENCHMARK_REPORT]: REPORT_TYPE_TEXT.BRAND_CATEGORY_BENCHMARK,
  [RMS_REPORT_TYPE.CAMPAIGN_PLACEMENTS_REPORT]: REPORT_TYPE_TEXT.CAMPAIGN_PLACEMENTS,
  [RMS_REPORT_TYPE.CHANNEL_PUBLISHER_PERFORMANCE_REPORT]: REPORT_TYPE_TEXT.CHANNEL_PUBLISHER_PERFORMANCE,
  [RMS_REPORT_TYPE.CAMPAIGN_PERFORMANCE_REPORT]: REPORT_TYPE_TEXT.CAMPAIGN_PERFORMANCE,
  [RMS_REPORT_TYPE.LANDING_PAGE_PERFORMANCE_REPORT]: REPORT_TYPE_TEXT.LANDING_PAGE_PERFORMANCE,
  [RMS_REPORT_TYPE.TOP_AUDIENCE_CONSIDERATION_REPORT]: REPORT_TYPE_TEXT.TOP_AUDIENCE_CONSIDERATION,
  [RMS_REPORT_TYPE.TOP_AUDIENCE_PURCHASES_REPORT]: REPORT_TYPE_TEXT.TOP_AUDIENCE_PURCHASES,
  [RMS_REPORT_TYPE.ALL_AUDIENCES_REPORT]: REPORT_TYPE_TEXT.ALL_AUDIENCES,
  [RMS_REPORT_TYPE.KEYWORDS_CREATIVE_REPORT]: REPORT_TYPE_TEXT.KEYWORDS_CREATIVE,
  [RMS_REPORT_TYPE.PROMOTED_PRODUCTS_REPORT]: REPORT_TYPE_TEXT.PROMOTED_PRODUCTS,
  [RMS_REPORT_TYPE.PROMOTED_PRODUCTS_ROLLUP_REPORT]: REPORT_TYPE_TEXT.PROMOTED_PRODUCTS_ROLLUP,
  [RMS_REPORT_TYPE.BRAND_HALO_PRODUCTS_REPORT]: REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS,
  [RMS_REPORT_TYPE.BRAND_HALO_PRODUCTS_ROLLUP_REPORT]: REPORT_TYPE_TEXT.BRAND_HALO_PRODUCTS_ROLLUP,
  [RMS_REPORT_TYPE.BRAND_HALO_SNAPSHOT_REPORT]: REPORT_TYPE_TEXT.BRAND_HALO_SNAPSHOT,
  [RMS_REPORT_TYPE.ATTRIBUTED_PURCHASES_REPORT]: REPORT_TYPE_TEXT.ATTRIBUTED_PURCHASES,
  [RMS_REPORT_TYPE.GROSS_AND_INVALID_TRAFFIC_REPORT]: REPORT_TYPE_TEXT.GROSS_AND_INVALID_TRAFFIC,
  [RMS_REPORT_TYPE.MATCHED_TARGET_REPORT]: REPORT_TYPE_TEXT.MATCHED_TARGETING,
  [RMS_REPORT_TYPE.PRICING_TRANSPARENCY]: REPORT_TYPE_TEXT.PRICING_TRANSPARENCY,
  [RMS_REPORT_TYPE.CONVERSION_PATH]: REPORT_TYPE_TEXT.CONVERSION_PATH,
  [RMS_REPORT_TYPE.BENCHMARKS]: REPORT_TYPE_TEXT.BENCHMARKS,
  [RMS_REPORT_TYPE.AUDIENCE_REPORT]: REPORT_TYPE_TEXT.AUDIENCE,
  [RMS_REPORT_TYPE.PROMPTS]: REPORT_TYPE_TEXT.PROMPTS,
  [RMS_REPORT_TYPE.VIDEO]: REPORT_TYPE_TEXT.VIDEO
};

export const ADSP_REPORT_TYPE_MAP = {
  [ADSP_REPORT_TYPE.CAMPAIGN]: REPORT_TYPE_TEXT.CAMPAIGN,
  [ADSP_REPORT_TYPE.INDUSTRY_STANDARD]: REPORT_TYPE_TEXT.INDUSTRY_STANDARD,
  [ADSP_REPORT_TYPE.INDUSTRY_STANDARD_V2]: REPORT_TYPE_TEXT.INDUSTRY_STANDARD,
  [ADSP_REPORT_TYPE.INVENTORY]: REPORT_TYPE_TEXT.INVENTORY,
  [ADSP_REPORT_TYPE.SITE_AND_SUPPLY]: REPORT_TYPE_TEXT.SITE_AND_SUPPLY,
  [ADSP_REPORT_TYPE.AUDIENCE]: REPORT_TYPE_TEXT.AUDIENCE,
  [ADSP_REPORT_TYPE.PRODUCTS]: REPORT_TYPE_TEXT.PRODUCTS,
  [ADSP_REPORT_TYPE.TECHNOLOGY]: REPORT_TYPE_TEXT.TECHNOLOGY,
  [ADSP_REPORT_TYPE.GEOGRAPHY]: REPORT_TYPE_TEXT.GEOGRAPHY,
  [ADSP_REPORT_TYPE.GEOGRAPHY_WITHOUT_DMA]: REPORT_TYPE_TEXT.GEOGRAPHY,
  [ADSP_REPORT_TYPE.CONTEXTUAL]: REPORT_TYPE_TEXT.CONTEXTUAL,
  [ADSP_REPORT_TYPE.THIRD_PARTY_FEES]: REPORT_TYPE_TEXT.THIRD_PARTY_FEES,
  [ADSP_REPORT_TYPE.CONVERSION_SOURCE]: REPORT_TYPE_TEXT.CONVERSION_SOURCE,
  [ADSP_REPORT_TYPE.OFF_AMAZON_CONVERSION]: REPORT_TYPE_TEXT.OFF_AMAZON_CONVERSION
};

export const GENERAL_REPORT_TO_RMS_REPORT_TYPE_MAP = {
  [REPORT_TYPE.ADS]: RMS_REPORT_TYPE.ADS_REPORT,
  [REPORT_TYPE.ALL_AUDIENCES]: RMS_REPORT_TYPE.ALL_AUDIENCES_REPORT,
  [REPORT_TYPE.ATTRIBUTED_PURCHASES]: RMS_REPORT_TYPE.ATTRIBUTED_PURCHASES_REPORT,
  [REPORT_TYPE.BRAND_HALO_PRODUCTS]: RMS_REPORT_TYPE.BRAND_HALO_PRODUCTS_REPORT,
  [REPORT_TYPE.BRAND_HALO_PRODUCTS_ROLLUP]: RMS_REPORT_TYPE.BRAND_HALO_PRODUCTS_ROLLUP_REPORT,
  [REPORT_TYPE.BRAND_HALO_SNAPSHOT]: RMS_REPORT_TYPE.BRAND_HALO_SNAPSHOT_REPORT,
  [REPORT_TYPE.BUDGETS]: RMS_REPORT_TYPE.BUDGETS_REPORT,
  [REPORT_TYPE.CAMPAIGN_PERFORMANCE]: RMS_REPORT_TYPE.CAMPAIGN_PERFORMANCE_REPORT,
  [REPORT_TYPE.CAMPAIGN_PLACEMENTS]: RMS_REPORT_TYPE.CAMPAIGN_PLACEMENTS_REPORT,
  [REPORT_TYPE.CAMPAIGNS]: RMS_REPORT_TYPE.CAMPAIGNS_REPORT,
  [REPORT_TYPE.CAMPAIGNS_V2]: RMS_REPORT_TYPE.CAMPAIGNS_REPORT,
  [REPORT_TYPE.CHANNEL_PUBLISHER_PERFORMANCE]: RMS_REPORT_TYPE.CHANNEL_PUBLISHER_PERFORMANCE_REPORT,
  [REPORT_TYPE.FIRETV_CAMPAIGNS]: RMS_REPORT_TYPE.FIRETV_CAMPAIGNS_REPORT,
  [REPORT_TYPE.GROSS_AND_INVALID_TRAFFIC]: RMS_REPORT_TYPE.GROSS_AND_INVALID_TRAFFIC_REPORT,
  [REPORT_TYPE.KEYWORDS_CREATIVE]: RMS_REPORT_TYPE.KEYWORDS_CREATIVE_REPORT,
  [REPORT_TYPE.KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST]: RMS_REPORT_TYPE.KEYWORDS_OFFLINE_REPORTING_API_LAUNCH_TEST,
  [REPORT_TYPE.KEYWORD_PLACEMENTS]: RMS_REPORT_TYPE.KEYWORD_PLACEMENTS_REPORT,
  [REPORT_TYPE.KEYWORDS]: RMS_REPORT_TYPE.KEYWORDS_REPORT,
  [REPORT_TYPE.LEGACY_CAMPAIGNS]: RMS_REPORT_TYPE.CAMPAIGNS_REPORT,
  [REPORT_TYPE.LANDING_PAGE_PERFORMANCE]: RMS_REPORT_TYPE.LANDING_PAGE_PERFORMANCE_REPORT,
  [REPORT_TYPE.MATCHED_TARGETING]: RMS_REPORT_TYPE.MATCHED_TARGET_REPORT,
  [REPORT_TYPE.PEER_BENCHMARK]: RMS_REPORT_TYPE.PEER_BENCHMARK_REPORT,
  [REPORT_TYPE.PLACEMENTS_V2]: RMS_REPORT_TYPE.PLACEMENTS_REPORT,
  [REPORT_TYPE.PROMOTED_PRODUCTS]: RMS_REPORT_TYPE.PROMOTED_PRODUCTS_REPORT,
  [REPORT_TYPE.PROMOTED_PRODUCTS_ROLLUP]: RMS_REPORT_TYPE.PROMOTED_PRODUCTS_ROLLUP_REPORT,
  [REPORT_TYPE.PURCHASED_PRODUCTS]: RMS_REPORT_TYPE.PURCHASED_PRODUCTS_REPORT,
  [REPORT_TYPE.PERFORMANCE_OVER_TIME]: RMS_REPORT_TYPE.PERFORMANCE_OVER_TIME_REPORT,
  [REPORT_TYPE.SEARCH_TERMS_IMPRESSION_RANK]: RMS_REPORT_TYPE.SEARCH_TERMS_IMPRESSION_RANK_REPORT,
  [REPORT_TYPE.SEARCH_TERMS]: RMS_REPORT_TYPE.SEARCH_TERMS_REPORT,
  [REPORT_TYPE.TOP_AUDIENCE_CONSIDERATION]: RMS_REPORT_TYPE.TOP_AUDIENCE_CONSIDERATION_REPORT,
  [REPORT_TYPE.TOP_AUDIENCE_PURCHASES]: RMS_REPORT_TYPE.TOP_AUDIENCE_PURCHASES_REPORT,
  [REPORT_TYPE.UNIFIED_ATTRIBUTED_PURCHASES]: RMS_REPORT_TYPE.ATTRIBUTED_PURCHASES_REPORT,
  [REPORT_TYPE.UNIFIED_CAMPAIGN_PLACEMENTS]: RMS_REPORT_TYPE.CAMPAIGN_PLACEMENTS_REPORT,
  [REPORT_TYPE.UNIFIED_CAMPAIGNS]: RMS_REPORT_TYPE.CAMPAIGNS_REPORT,
  [REPORT_TYPE.UNIFIED_KEYWORDS]: RMS_REPORT_TYPE.KEYWORDS_REPORT,
  [REPORT_TYPE.UNIFIED_SEARCH_TERMS]: RMS_REPORT_TYPE.SEARCH_TERMS_REPORT,
  [REPORT_TYPE.PROMPTS]: RMS_REPORT_TYPE.AUDIENCE_REPORT,
  [REPORT_TYPE.VIDEO]: RMS_REPORT_TYPE.VIDEO,
  [REPORT_TYPE.AUDIENCE]: RMS_REPORT_TYPE.AUDIENCE_REPORT
};

export const RDD_REPORT_TYPES: string[] = [
  RMS_REPORT_TYPE.SEARCH_TERMS_REPORT,
  RMS_REPORT_TYPE.KEYWORDS_REPORT,
  RMS_REPORT_TYPE.ADS_REPORT,
  RMS_REPORT_TYPE.CAMPAIGNS_REPORT,
  RMS_REPORT_TYPE.PLACEMENTS_REPORT,
  RMS_REPORT_TYPE.GROSS_AND_INVALID_TRAFFIC_REPORT
];

export function getReportTypeTranslationKey(
  reportTypeId: RMS_REPORT_TYPE | REPORT_TYPE | ADSP_REPORT_TYPE,
  reportCategoryId?: REPORT_CATEGORY
): REPORT_TYPE_TEXT | string {
  // TODO Verify that we should unify this reportType SIM: https://sim.amazon.com/issues/RCMRX-6321
  if (reportTypeId === REPORT_TYPE.KEYWORDS || reportTypeId === RMS_REPORT_TYPE.KEYWORDS_REPORT) {
    if (reportCategoryId === REPORT_CATEGORY.SP || reportCategoryId === REPORT_CATEGORY.SD) {
      return REPORT_TYPE_TEXT.TARGETING;
    }
    return REPORT_TYPE_TEXT.KEYWORD;
  }

  if (
    !RMS_REPORT_TYPE_MAP[reportTypeId as RMS_REPORT_TYPE] &&
    !GENERAL_REPORT_TYPE_MAP[reportTypeId as REPORT_TYPE] &&
    !ADSP_REPORT_TYPE_MAP[reportTypeId as ADSP_REPORT_TYPE]
  ) {
    logger.logWarningMessage(`No report type found for reportTypeId:`, { reportTypeId });
    return reportTypeId;
  }

  return (
    RMS_REPORT_TYPE_MAP[reportTypeId as RMS_REPORT_TYPE] ||
    GENERAL_REPORT_TYPE_MAP[reportTypeId as REPORT_TYPE] ||
    ADSP_REPORT_TYPE_MAP[reportTypeId as ADSP_REPORT_TYPE]
  );
}
